import { GET_LOADING_TYPE } from './loading.actionTypes';

export const loadingAction = (action, type = GET_LOADING_TYPE , key='loading') => {
    return (dispatch) => {
        dispatch({
            type,
            [key]: true
        });
        return action(dispatch, () => {
            dispatch({
                type,
                [key]: false
            });
        });
    }
}